export const WHITE_LABEL_THESIS = {
  headline: "Stop Being the Victim. Weaponize the Infrastructure.",
  thesisLead: "Don't let third-party tech intercept your traffic. ",
  thesisAccent: "Claim the infrastructure under your own white-label.",
};

export const WHITE_LABEL_PILLARS = [
  {
    id: "brand",
    label: "YOUR BRAND",
    headline: "Proprietary tech stack",
    sub: "Deploy under white-label. Clients never see FractoLabs.",
  },
  {
    id: "book",
    label: "YOUR BOOK",
    headline: "Retain and hunt",
    sub: "Unreplicable weapon to keep clients and win new ones.",
  },
  {
    id: "margin",
    label: "YOUR MARGIN",
    headline: "100% of the spread",
    sub: "Wholesale in. Retail out. You keep every dollar.",
  },
];

export const WHITE_LABEL_SPLIT = {
  hidden: {
    label: "FractoLabs (hidden)",
    items: ["Backend infrastructure", "Policy engine", "CRM sync"],
  },
  visible: {
    label: "Your agency (visible)",
    items: ["White-label deployment", "Client-facing utility", "Your invoice"],
  },
};

export const WHITE_LABEL_HERO_METRIC = {
  value: "100%",
  label: "of the margin spread stays with you",
  caption: "We build the backend. You own the client relationship.",
};

export const WHITE_LABEL_DETAILS = {
  summary: "How white-label works",
  paragraphs: [
    "Don't let third-party tech intercept your traffic. Claim the infrastructure under your own white-label, deploy it as your proprietary technology, and use it as an unreplicable weapon to retain current clients and hunt new ones.",
    "We build the backend; you own the client relationship. FractoLabs operates under a completely neutral, unbranded system domain with zero upstream footprints. Your clients see a high-end corporate utility. You keep 100% of the margin spread.",
  ],
};

export const WHITE_LABEL_CTA = "Apply for Partner Access";

// Legacy exports for any external imports
export const WHITE_LABEL_BODY = WHITE_LABEL_DETAILS.paragraphs[1];
